
  import ConfigAppraisal from '@/components/config/genio/ConfigAppraisal.vue'
  import ConfigEnablement from '@/components/config/genio/ConfigEnablement.vue'
  import ConfigEvaluation from '@/components/config/genio/ConfigEvaluation.vue'
  import ConfigFinancing from '@/components/config/genio/ConfigFinancing.vue'
  import ConfigGoals from '@/components/config/genio/ConfigGoals.vue'
  import ConfigInspection from '@/components/config/genio/ConfigInspection.vue'
  import ConfigLead from '@/components/config/genio/ConfigLead.vue'
  import ConfigLeadActivity from '@/components/config/genio/ConfigLeadActivity.vue'
  import ConfigMaintenance from '@/components/config/genio/ConfigMaintenance.vue'
  import ConfigNegotiation from '@/components/config/genio/ConfigNegotiation.vue'
  import ConfigPayment from '@/components/config/genio/ConfigPayment.vue'
  import ConfigPurchase from '@/components/config/genio/ConfigPurchase.vue'
  import ConfigReserve from '@/components/config/genio/ConfigReserve.vue'
  import ConfigSale from '@/components/config/genio/ConfigSale.vue'
  import ConfigStock from '@/components/config/genio/ConfigStock.vue'
  import ConfigVehicle from '@/components/config/genio/ConfigVehicle.vue'
  import PTitle from '@/components/config/PTitle.vue'
  import { GForm } from '@/components/forms/GForm'
  import { Process } from '@/entities/settings'
  import { plainToInstance } from 'class-transformer'
  import { Component, Watch } from 'vue-property-decorator'

@Component({
  components: { PTitle, ConfigAppraisal, ConfigEnablement, ConfigEvaluation, ConfigFinancing, ConfigInspection, ConfigLead, ConfigLeadActivity, ConfigMaintenance, ConfigNegotiation, ConfigPayment, ConfigPurchase, ConfigReserve, ConfigSale, ConfigStock, ConfigVehicle, ConfigGoals },
})
  export default class SystemConfig extends GForm {
// Lista de procesos (cada proceso tiene su config y configMessage)
process: Process[] = []

// Índice seleccionado en la lista de la izquierda
selected = null

// Búsqueda en la lista de procesos
search = null

// Control de paneles abiertos en la vista principal
panelsOpen = [0]

// Control de paneles abiertos en el nivel de sub-secciones
panelsOpenSection = [0]

// Clave única para forzar la reconstrucción de componentes
componentKey = 0

// Bandera para evitar actualizaciones recursivas entre watchers
isUpdating = false

// Objeto donde se almacenan el proceso actual y los valores editables
formData = {
  process: null as any,
  values: {} as Record<string, any>,
}

/**
 * Computed: Filtra la lista de procesos de acuerdo a la búsqueda actual.
 * Además, sincroniza el índice seleccionado.
 */
get filteredProcess () {
  if (!this.search?.length) {
    const lastProcess = this.formData.process

    this.selected = this.process.findIndex(p => p.id === lastProcess?.id)
    return this.process
  }
  return this.process.filter((p: Process) =>
    p.description.toLowerCase().includes(this.search?.toLowerCase())
  )
}

/**
 * Ciclo de vida: Al montar, busca los procesos con configMessage.
 */
 async created () {
  await this.loadProcesses()
}

/**
 * Carga todos los procesos desde la base de datos
 */
async loadProcesses () {
  const processes = await this.fetchData({
    query: { name: 'find', model: 'Process', order: { order: 'asc' } },
    filter: {
      _and: [
        { config: { _is_null: false } },
        { table_name: { _nin: ['maintenance', 'evaluation', 'lead_activity', 'financing'] } },
      ],
    },
    force: true,
  })
  processes.push(plainToInstance(Process, { id: -1, tableName: 'goals', description: 'Metas mensuales' }))
  this.process = processes
}

/**
 * Recarga los datos del proceso actual
 */
async reloadCurrentProcess () {
  if (!this.formData.process || this.formData.process.id === -1) return

  const updatedProcess = (await this.fetchData({
    query: { name: 'find', model: 'Process' },
    filter: { id: { _eq: this.formData.process.id } },
    force: true,
  }))[0]

  if (updatedProcess) {
    // Actualizar el proceso en la lista
    const index = this.process.findIndex(p => p.id === updatedProcess.id)
    if (index !== -1) {
      this.process[index] = updatedProcess
    }
    this.formData.process = updatedProcess
  }
}

async refreshConfig () {
    await this.loadNotification({
      // @ts-ignore
      message: `Proceso actualizado`,
      notificationType: 'success',
    })
  }

/**
 * Watcher: Cuando cambia el índice seleccionado, actualiza formData.process.
 */
@Watch('selected', { immediate: true })
async onSelectedChange (val) {
  if (val === -1 || val === null || val === undefined || this.isUpdating) {
      return
  }

  try {
    this.isUpdating = true

    // Actualizar el proceso seleccionado
    const newProcess = this.filteredProcess[val]

    // Verificar si realmente hay un cambio antes de actualizar
    if (this.formData.process && this.formData.process.tableName === newProcess.tableName) {
      return
    }

    // Incrementar la clave para forzar la reconstrucción del componente
    this.componentKey++

    this.formData.process = newProcess

    // Si no es el proceso "Metas mensuales", recargarlo de la base de datos
    if (this.formData.process.id !== -1) {
      await this.reloadCurrentProcess()
    }

    this.$router.replace({
        query: {
          ...this.$route.query, // mantiene los parámetros existentes
          process: this.formData.process.tableName,
        },
      }).catch(() => {
      })
  } finally {
    this.isUpdating = false
  }
}

get routeAndProcess () {
    const { process, $route } = this

    return {
      process,
      route: $route,
    }
  }

/**
 * Actualiza los datos y recarga el proceso seleccionado
 */
async updateSelectedProcess (foundProcess) {
  // Verificar si realmente hay un cambio
  if (this.formData.process && this.formData.process.tableName === foundProcess.tableName) {
    return
  }

  this.formData.process = foundProcess

  // Si no es el proceso "Metas mensuales", recargarlo de la base de datos
  if (this.formData.process.id !== -1) {
    await this.reloadCurrentProcess()
  }
}

/**
 * Actualiza el proceso cuando cambia la ruta
 */
@Watch('routeAndProcess', { immediate: true, deep: true })
async onRouteChange (val) {
  if (!val?.route || !val?.process?.length || this.isUpdating) {
    return
  }

  const { query } = val.route

  try {
    this.isUpdating = true

    if (query?.process) {
      const index = this.process.findIndex(p => p.tableName === query.process)

      // Verificar si ya está seleccionado el mismo proceso
      if (this.selected === index) {
        return
      }

      this.selected = index
      this.componentKey++ // Incrementar la clave para reconstruir el componente

      const foundProcess = this.process.find(p => p.tableName === query.process)
      if (foundProcess) {
        await this.updateSelectedProcess(foundProcess)
      }
    } else if (this.selected !== 0) {
      // Si no hay proceso seleccionado en la URL, seleccionar el primero
      this.selected = 0
      this.componentKey++ // Incrementar la clave para reconstruir el componente

      const firstProcess = this.filteredProcess?.length ? this.filteredProcess[0] : this.process[0]
      if (firstProcess) {
        await this.updateSelectedProcess(firstProcess)
      }
    }
  } finally {
    this.isUpdating = false
  }
}
  }
